// Eigenes Passwort ändern – für alle eingeloggten User.

import { useState } from 'react';

import { api } from '../api.js';
import Modal from './Modal.jsx';

export default function ChangePassword({ onClose }) {
    const [currentPw, setCurrentPw] = useState('');
    const [newPw, setNewPw] = useState('');
    const [newPw2, setNewPw2] = useState('');
    const [error, setError] = useState('');
    const [saving, setSaving] = useState(false);
    const [done, setDone] = useState(false);

    async function submit(e) {
        e.preventDefault();
        setError('');
        if (newPw !== newPw2) {
            setError('Die neuen Passwörter stimmen nicht überein.');
            return;
        }
        if (newPw.length < 8) {
            setError('Das neue Passwort muss mindestens 8 Zeichen lang sein.');
            return;
        }
        setSaving(true);
        try {
            await api.changeOwnPassword(currentPw, newPw);
            setDone(true);
        } catch (err) {
            if (err.status === 401) {
                setError('Aktuelles Passwort ist falsch.');
            } else {
                setError(err.message || 'Passwortwechsel fehlgeschlagen');
            }
        } finally {
            setSaving(false);
        }
    }

    return (
        <Modal title="Passwort ändern" onClose={onClose}>
            {done ? (
                <div>
                    <p>Passwort wurde aktualisiert.</p>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <button type="button" className="btn btn--primary" onClick={onClose}>
                            Schließen
                        </button>
                    </div>
                </div>
            ) : (
                <form onSubmit={submit}>
                    {error && <div className="login__error" style={{ marginBottom: 12 }}>{error}</div>}
                    <div className="field">
                        <label>Aktuelles Passwort</label>
                        <input
                            type="password"
                            value={currentPw}
                            onChange={(e) => setCurrentPw(e.target.value)}
                            required
                            autoFocus
                        />
                    </div>
                    <div className="field">
                        <label>Neues Passwort (mind. 8 Zeichen)</label>
                        <input
                            type="password"
                            value={newPw}
                            onChange={(e) => setNewPw(e.target.value)}
                            minLength={8}
                            required
                        />
                    </div>
                    <div className="field">
                        <label>Neues Passwort wiederholen</label>
                        <input
                            type="password"
                            value={newPw2}
                            onChange={(e) => setNewPw2(e.target.value)}
                            minLength={8}
                            required
                        />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                        <button type="button" className="btn" onClick={onClose}>Abbrechen</button>
                        <button type="submit" className="btn btn--primary" disabled={saving}>
                            {saving ? 'Speichert…' : 'Speichern'}
                        </button>
                    </div>
                </form>
            )}
        </Modal>
    );
}
